import { isAdmin, isMember, isGuest } from '@/policies/';
var equipment = {
    create: function (company) {
        return isAdmin(company.user_type);
    },
    update: function (company) {
        return isAdmin(company.user_type);
    },
    delete: function (company) {
        return isAdmin(company.user_type);
    },
    duplicate: function (company) {
        return isAdmin(company.user_type);
    },
    showTaskMenu: function (company) {
        return isAdmin(company.user_type) || isMember(company.user_type) || isGuest(company.user_type);
    },
    navigateStatusAlert: function (company) {
        return isAdmin(company.user_type);
    }
};
export default equipment;
